.lead-sidebar {
    display: flex;
    flex-direction: column;
    width: 300px;
    height: 100%;
    border-left: 1px solid var(--off-white-dk);
    box-sizing: border-box;
}

.lead-sidebar--collapsed {
    width: 50px;
    min-width: 50px;
}
